import { render, staticRenderFns } from "./adminStatistic.vue?vue&type=template&id=8ae8d006&scoped=true"
import script from "./adminStatistic.vue?vue&type=script&lang=js"
export * from "./adminStatistic.vue?vue&type=script&lang=js"
import style0 from "./adminStatistic.vue?vue&type=style&index=0&id=8ae8d006&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae8d006",
  null
  
)

export default component.exports